"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.socketEvents = void 0;
var json_rpc_dispatcher_1 = require("@dealroadshow/json-rpc-dispatcher");
var socket_frontend_sdk_1 = require("@dealroadshow/socket-frontend-sdk");
var ProcessingEvent_1 = require("./ProcessingEvent");
exports.socketEvents = [
    'file.processing',
];
var FinsightSocketProcessingAdapter = /** @class */ (function () {
    function FinsightSocketProcessingAdapter(socket) {
        this.socket = socket;
        this.socketSubscription = null;
        this.canceled = false;
        this.processed = false;
    }
    /**
     * Process file
     */
    FinsightSocketProcessingAdapter.prototype.init = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, processingCallback, callbackWrapper;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.socket.subscribe(new json_rpc_dispatcher_1.RpcRequest({
                                method: 'finsight_web.socket.notifications',
                                params: {
                                    payload: { entityId: uuid }
                                },
                            }))];
                    case 1:
                        _a.socketSubscription = _b.sent();
                        processingCallback = function (payload) {
                            if (payload.status === 'UPLOAD_ERROR') {
                                _this.emitProcessingJoinChunksError({
                                    uuid: uuid,
                                    payload: payload,
                                });
                                _this.processed = true;
                                return;
                            }
                            if (payload.status === 'PROCESSING_ERROR') {
                                _this.emitProcessingError({
                                    uuid: uuid,
                                    payload: payload,
                                });
                                _this.processed = true;
                                return;
                            }
                            if (payload.status === 'RESTRICT') {
                                _this.emitProcessingError({
                                    uuid: uuid,
                                    payload: payload,
                                });
                                _this.processed = true;
                                throw payload;
                            }
                            if (payload.status === 'PROCESSED') {
                                _this.eventEmitter.emit(ProcessingEvent_1.ProcessingEvent.processingDone, __assign(__assign({}, payload), { uuid: uuid }));
                                _this.processed = true;
                                return;
                            }
                            _this.eventEmitter.emit(ProcessingEvent_1.ProcessingEvent.processing, __assign(__assign({}, payload), { uuid: uuid }));
                        };
                        callbackWrapper = function (callback) { return function (_a) {
                            var payload = _a.params.payload;
                            return callback(payload);
                        }; };
                        exports.socketEvents.forEach(function (event) { return _this.socketSubscription.on(event, callbackWrapper(processingCallback)); });
                        this.socketSubscription.on('disconnect', function (reason) {
                            if (_this.processed || _this.canceled) {
                                return;
                            }
                            _this.eventEmitter.emit(ProcessingEvent_1.ProcessingEvent.disconnect, {
                                reason: reason,
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Cancel processing
     */
    FinsightSocketProcessingAdapter.prototype.cancel = function () {
        if (this.socketSubscription instanceof socket_frontend_sdk_1.Subscription) {
            this.canceled = true;
            return this.socketSubscription.cancel();
        }
        return Promise.resolve();
    };
    /**
     * Emit error
     */
    FinsightSocketProcessingAdapter.prototype.emitProcessingError = function (_a) {
        var uuid = _a.uuid, payload = _a.payload;
        this.eventEmitter.emit(ProcessingEvent_1.ProcessingEvent.processingError, __assign(__assign({}, payload), { uuid: uuid }));
        this.eventEmitter.emit(ProcessingEvent_1.ProcessingEvent.error, __assign(__assign({}, payload), { uuid: uuid }));
    };
    /**
     * Emit error
     */
    FinsightSocketProcessingAdapter.prototype.emitProcessingJoinChunksError = function (_a) {
        var uuid = _a.uuid, payload = _a.payload;
        this.eventEmitter.emit(ProcessingEvent_1.ProcessingEvent.processingJoinChunksError, __assign(__assign({}, payload), { uuid: uuid }));
        this.eventEmitter.emit(ProcessingEvent_1.ProcessingEvent.error, __assign(__assign({}, payload), { uuid: uuid }));
    };
    /**
     * Set event emitter
     */
    FinsightSocketProcessingAdapter.prototype.setEventEmitter = function (eventEmitter) {
        this.eventEmitter = eventEmitter;
        return this;
    };
    return FinsightSocketProcessingAdapter;
}());
exports.default = FinsightSocketProcessingAdapter;
//# sourceMappingURL=FinsightSocketProcessingAdapter.js.map